// Ionic & Angular Imports
import {Component} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Events, AlertController, PopoverController, ViewController, NavController,
        NavParams, LoadingController, Loading} from 'ionic-angular';

// Service Imports
import {rsReportSvc, ReportState} from '../../../../services/report.service';

// Component Imports
import {BasePage} from '../../../base.component';

@Component({
    templateUrl: 'schedule.html',
})
export class SchedulePage extends BasePage
{
    // Class member variables
    private modalForm              : FormGroup;
    private initScheduleStatus     : boolean;
    private initScheduleImpacts    : string;

    constructor( 
        protected alertCtrl : AlertController,
        private navCtrl : NavController,
        private navParams : NavParams, 
        private reportSvc: rsReportSvc, 
        private loadingCtrl : LoadingController,
        private viewCtrl : ViewController,
        private formBuilder : FormBuilder,
        private popupCtrl : PopoverController,
        private eventSystem : Events
    ){
        // Construct base class
        super( alertCtrl );

        interface NavData {
            onschedule : boolean;
            scheduleimpacts: string;
        };

        // Retrieve the activity list from our NavParams       
        let navData : NavData = <NavData>this.navParams.get('content');

        this.initScheduleStatus = navData.onschedule;
        this.initScheduleImpacts = navData.scheduleimpacts;

        // Build our form model structure
        this.buildFormModel();
    }

    // Class method for builidng our form model structure 
    private buildFormModel() {
        this.modalForm = this.formBuilder.group({
            schedule_impacts:      [this.initScheduleImpacts],
            on_schedule:           [this.initScheduleStatus]
        });
    }

    // Class helper method for setting a field in the form to a specified value
    private setFormField( fieldName: string, fieldValue: any ) {
        this.modalForm.controls[fieldName].setValue( fieldValue );
        this.modalForm.controls[fieldName].markAsDirty();
    }


    // Class helper method to allow the check box to toggle when the label is pressed
    public toggleOnSchedule() {
        // Set hte form field to the opposite of the current value
        this.setFormField( 'on_schedule', <boolean>!this.modalForm.controls['on_schedule'].value)
    }        
    
    public modalReset() {
        this.modalForm.reset( {
            schedule_impacts:      this.initScheduleImpacts,
            on_schedule:           this.initScheduleStatus
        });
    }

    public modalSubmit( formData : any, isValid : boolean ) {
        // Display a loader while the modal submits our changes
        let loader : Loading = this.loadingCtrl.create({
            content: 'Updating...',
            dismissOnPageChange: true
        });
        loader.present().then( () => {
            // Determine what the submit button shoudl be doing based on the validity
            // of the form and the mode of the modal.
            if( isValid === true) {
                this.reportSvc.updateScheduleImpacts( this.reportSvc.getActiveReportId(), formData.on_schedule, formData.schedule_impacts ).subscribe( result => {
                    this.eventSystem.publish('report:updated', ReportState.ScheduleImpacts, result );
                }, err => {
                    // Operation failed; dismiss loader and display an error message
                    loader.dismiss().then( () => {
                        this.displayError("There was an error updating the report.  Please try again later." );
                    });
                }, () => {
                    // Operation complete, let's navigate back
                    this.navCtrl.pop();
                });
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/report/tab-main/schedule/schedule.component.ts